import React from 'react';
import Router from 'next/router';
import withStore from 'utils/withStore';
import Authentication from 'stores/authentication';
import ConfigStore from 'stores/config';

import { USER_ROLE } from 'components/shared/constants';

const { OWNER } = USER_ROLE;

class Page extends React.Component {
  async componentDidMount() {
    const { authenticationStore, configStore } = this.props;

    const isLoggedIn = await authenticationStore.isLoggedIn;
    if (configStore && isLoggedIn) {
      await configStore.loadMenu();
    }

    if (!isLoggedIn) {
      Router.push('/login');
      return;
    }

    const isOwner = authenticationStore.loggedInUser.userRoles.some(({ role }) => role === OWNER);

    if (isOwner) {
      Router.push('/owners/royaltydashboard');
      return;
    }

    Router.push('/affiliates/commissions');
  }

  render() {
    return (
      <div className="pageloader is-active">
        <span className="title" />
      </div>
    );
  }
}

export default withStore(Authentication, ConfigStore)(Page);
